import type { JSX } from 'react'
import type { IAuthFormBoxProps } from '../AuthFormBox'

import { AuthFormBox } from '../AuthFormBox'
import {
  AuthFormBoxAlignItems,
  AuthFormBoxPaddings,
  AuthFormBoxRowGaps,
} from '../AuthFormBox.h'

export interface IAuthFormBoxTrueIdTemplateProps extends IAuthFormBoxProps {}

export const AuthFormBoxTrueIdTemplate = ({
  children,
  width = 460,
  padding = AuthFormBoxPaddings.SIZE_140,
  rowGap = AuthFormBoxRowGaps.SIZE_60_0,
  alignItems = AuthFormBoxAlignItems.Center,
  ...rest
}: IAuthFormBoxTrueIdTemplateProps): JSX.Element => (
  <AuthFormBox
    width={width}
    padding={padding}
    rowGap={rowGap}
    alignItems={alignItems}
    {...rest}
  >
    {children}
  </AuthFormBox>
)

AuthFormBoxTrueIdTemplate.displayName = 'AuthFormBoxTrueIdTemplate'
